import React,{Component} from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
export default class ContactFr extends Component{
   constructor(props){
    super(props)
    this.submit = this.submit.bind(this)
  }
  state = {
    sending: false,
    sent: false,
  }
   submit(event) {
    this.setState({sending : true})
    event.preventDefault();
    const data = new FormData(event.target);
    const name = data.get('nom_complet')
    const organization = data.get('compagnie')
    const phone = data.get('telephone')
    const email = data.get('courriel')
    const comment = data.get('commentaire')
    const language = "français"
    console.log(name)
    axios.post("https://groupegamache.com/json/expert-en-sinistre/contact",{name,organization,phone,email,comment,language})
    .then((response)=>{
        Swal({
          type : `success`,
          title : `Message envoyé`,
          text : `Votre message a été envoyé avec succès.`
        })
        this.setState({sending : false, sent: true})
       document.getElementById('contact_form').reset()
    })
    .catch(error=>{
      console.log(error)
    })
    
  }
  render(){
    return(

              <div>
        <title>GAMEX l’expert après sinistre en transport</title>
        <link rel="stylesheet" href="css/style.css" />
        <div className="top_nav">
          <div className="container">
            {/*<span className="btn btn-primary btn-sm pull-right" data-toggle="modal" data-target=".login_modal">Connexion</span>*/}
            <a href="/accident-recovery-expert/contact" className="btn btn-primary btn-sm  pull-right">EN</a>  
          </div></div>
        <header className>
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-8 col-sm-12 col-xs-12">
                <h1 className="logged fr">
                  <span>Vous pouvez maintenant</span><span>nous laisser prendre</span><span>les choses en main</span><span>en toute quiétude.</span>          
                </h1>
              </div>
              <div className="col-lg-6 col-md-4 hidden-sm hidden-xs">
                <img className="img-responsive logo" src={require('../assets/img/logo_gamex_fr.png')} alt="GAMEX l’expert après sinistre en transport" />
              </div>
            </div>
          </div>
        </header>
        <div className="scroller_anchor" />
        <nav id="navigation" className="scroller">
          <ul className="nav">
            <li id="accueil" className="col-md-2 col-sm-3 col-xs-3"><a href="/expert-en-sinistre#header">Accueil</a></li>
            <li className="col-md-2 col-sm-3 col-xs-3 "><a href="/expert-en-sinistre#gamex_plus">Qui sommes-nous ?</a></li>
            <li className="col-md-2 col-sm-3 col-xs-3"><a href="/expert-en-sinistre#pourquoi_gamex">Expertise</a></li>
            <li className="col-md-2 col-sm-3 col-xs-3"><a href="/expert-en-sinistre/contact">Nous joindre</a></li>
          </ul>
          <div className="col-md-2 hidden-sm hidden-xs" />
          <div className="col-md-2 hidden-sm hidden-xs" />
        </nav>    
        <section id="contact">
          <div className="container">
            <div className="col-md-6">
              <h2>COMMUNIQUEZ AVEC NOUS {/*not connect*/}</h2>
              <p className="lead">VOUS POUVEZ NOUS JOINDRE EN TOUT TEMPS.<br />
                24 HEURES PAR JOUR ET 7 JOURS SUR 7.</p>
              Numéro sans frais (Canada et États-Unis) : <strong>1-866-635-4402</strong>        <hr />
              <a href="tel:18666354402" className="btn btn-primary btn-lg visible-xs">Contactez-nous</a>
            </div>
            <div className="col-md-6 form_holder">
              {this.state.sending ?'Envoi de votre message...': ''}
              {this.state.sent ?'Message envoyé!': ''}
              <p className="lead">Laissez-nous vos coordonnés et nous vous contacterons rapidement.</p>
              <form className="form" id="contact_form" onSubmit={this.submit}>
                <div className="form-group">
                  {/*<label for="nom_complet">Nom complet</label>*/}
                  <input type="text" name="nom_complet" id="nom_complet" className="form-control" placeholder="Nom complet" />
                </div>
                <div className="form-group">
                  {/*<label for="compagnie">Compagnie</label>*/}
                  <input type="text" name="compagnie" id="compagnie" className="form-control" placeholder="Compagnie / Organisation" />
                </div>
                <div className="form-group">
                  {/*<label for="telephone">Téléphone</label>   */}
                  <input type="text" name="telephone" id="telephone" className="form-control" placeholder="514 555-5555 (obligatoire)" required />
                </div>
                <div className="form-group">
                  {/*<label for="courriel">Courriel</label>*/}
                  <input type="text" name="courriel" id="courriel" className="form-control" placeholder="courriel@domaine.com (obligatoire)" required />
                </div>
                <div className="form-group">
                  {/*<label for="commentaire">Commentaire</label>*/}
                  <textarea name="commentaire" id="commentaire" className="form-control" rows={5} cols placeholder="commentaire" defaultValue={""} />
                </div>
                <input id="submit" type="submit" className="btn btn-primary" defaultValue="Envoyer" /><div id="response" />
              </form>
            </div>
          </div>
        </section>
        <br/>
        <footer className>
          <div className="container">
            <div className="col-md-12">
              <h1><span className="logotype">GAMEX</span> Expert en sinistre</h1>
            </div>
          </div>
        </footer>
        <div className="modal fade login_modal" tabIndex={-1} role="dialog" aria-labelledby="login_modal">
          <div className="modal-dialog modal-sm">
            <form action="modal_login.php" method="post">
              <div className="modal-content">
                <h1>
                  Veuillez-vous connecter.    </h1>
                <p className="lead">
                  Vous devez être connecté pour accéder à cette section.    </p>
                <div className="form-group">
                  <input className="form-control" type="text" name="email" placeholder="Courriel" required />
                </div>
                <div className="form-group">
                  <input className="form-control" type="password" name="pass" placeholder="Mot de passe" required />
                </div>
                <div className="form-group">
                  <button type="submit" name="btn-login" className="btn btn-primary">Se connecter</button>
                  <hr />
                  <a className href="contact.php">Vous n’avez pas d’accès?</a>
                </div>
              </div>
            </form>
          </div>
        </div>
        {/* Act-On Tracking */}
        {/* END Act-On */}
      </div>







      )
  }
}


// WEBPACK FOOTER //
// ./src/components/ContactFr.js